import { v4 as uuidv4 } from 'uuid';
import { getFaasApiUrl } from '@/selectors/configSelectors';
import { getAuthentication, setAuthentication } from '@/duck/authDuck';
import { getWallet, setWallet } from '@/duck/walletDuck';
import { getBdaasLoungeFinderBaseUrl } from '@/selectors/bdaasSelectors';

export const fetchOptions = {
  mode: 'cors',
  credentials: 'include',
  'one-data-correlation-id': uuidv4(),
};

export const readUserSession = async (faasApiUrl, fetchClient = fetch) => {
  const response = await fetchClient(
    `${faasApiUrl}/ReadUserSession.v1`,
    fetchOptions
  );
  return response.ok;
};

export const fetchWallet =
  (bdaasUrl, fetchClient = fetch) =>
  async (dispatch) => {
    const walletFetchOptions = { ...fetchOptions, method: 'POST' };

    await dispatch(getWallet());
    const response = await fetchClient(
      `${bdaasUrl}/user/profile`,
      walletFetchOptions
    );
    return response.json();
  };

export const checkIsLoggedInThunk =
  (fetchClient) => async (dispatch, getState) => {
    dispatch(getAuthentication());
    const faasApiUrl = getFaasApiUrl(getState());

    const isAuthenticated = await readUserSession(faasApiUrl, fetchClient);

    await dispatch(setAuthentication(isAuthenticated));
    return isAuthenticated;
  };

export const isAuthenticatedAndLoadWallet =
  (fetchClient) => async (dispatch, getState) => {
    const isAuthenticated = await dispatch(checkIsLoggedInThunk(fetchClient));
    const state = getState();
    const bdaasUrl = getBdaasLoungeFinderBaseUrl(state);

    if (isAuthenticated) {
      const walletData = await dispatch(fetchWallet(bdaasUrl, fetchClient));
      const {
        userSession: {
          profile: { accounts = [] },
        },
      } = walletData;
      await dispatch(setWallet(accounts));
    }
  };
